<div class="fulfillmentLanding pre-pay">
  <div class="row">
    <div class="col-md-12 col-lg-12 margin-l0 prepayTopSec">
      <h1>
        Prepay Contracts:
      </h1>
      <p class="smalltext">
        Your listing of accounts that include request and their status. Click on a request to see their balance ledger.
        To create a new pre-pay request click on the button below and fill out the application.
      </p>
    </div>
    <div class="col-md-12 col-lg-12">
      <div class="search-box landingPageSearch">

        <span class="search-icon">
          <i class="fas fa-search"></i>
        </span>

        <div class="select-container material-select">
          <ng-select [items]="accountList"
                     [virtualScroll]="true"
                     [(ngModel)]="selectedAccount"
                     bindLabel="accountNameCityState"
                     bindValue="accountNumber"
                     placeholder="Select Account"
                     (change)="accountChange($event)"
                     class="custom-select-grower searchIcon lpSearch"
                     (clear)="clearAccount()"
                     [searchFn]="accountSearchFn">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template">
                <div class="row">
                  <div class="col-md-8">
                    <h5 *ngIf="item.accountNumber == item.parentNumber">
                      Parent
                    </h5>
                    <h4 class="name greenColor" [ngOptionHighlight]="search">
                      {{item.accountName}}
                    </h4>
                    <p class="address" [ngOptionHighlight]="search">
                      {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                    </p>
                    <p class="phoneNo" [ngOptionHighlight]="search">
                      {{item.primaryPhoneNumber}}
                    </p>
                    <p class="grower-nos">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Account#: {{item.accountNumber}}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
            <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
              <div class="ng-option disabled">
                No data found for "{{searchTerm}}"
              </div>
            </ng-template>
            <ng-template ng-footer-tmp let-search="searchTerm">
              <div class="custom-drop-footer">
                <div class="row">
                  <div class="col-md-12">
                    Select an option above to filter
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <mat-tab-group disableRipple [animationDuration]="'400ms'" class="matTabs prepayLandingTab">
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="icon-ico-grower_icon" aria-hidden="true"></i>
            <div class="tab-head">
              <h4>
                Active & Pending Contracts
              </h4>
            </div>
          </ng-template>
          <div class="fulfill-top-sec">
            <div class="row listing-action-items">
              <div class="col-xl-4 col-lg-4 col-md-3 smallPadRgt0">
              </div>
              <div class="col-xl-8 col-lg-8 col-md-9 text-right smallPadLeft0 padding-r10">
                <div class="display-ib wAuto">
                  <mat-paginator #activePendingContractsPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                </div>
                <span class="margin-l20 text-right smallPadLeft0 smallMarLeft0 valignTop">
                  <button *ngIf="accessTypeMode" mat-raised-button class="btns margin-l5" color="primary" (click)="addPrePayRequest()">Create New Contract</button>
                </span>
              </div>
            </div>
          </div>
          <div class="tableContainer growertableContainer">
            <table mat-table #activePendingContractsTable [dataSource]="activePendingContractsDataSource" matSort #activePendingContractsSort matSortDirection="desc" class="matTables">

              <ng-container matColumnDef="contractNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="prepayAcc"> Prepay Contract </th>
                <td mat-cell *matCellDef="let element" class="unitsText">
                  <div (click)="navigateToContractInfo(element)">
                    <a>{{element.contractNumber}}</a>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef class=""> Prepay Contracts: {{getTotalContracts()}} </td>
              </ng-container>
              <ng-container matColumnDef="cropYear">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cropYear"> Crop Year </th>
                <td mat-cell *matCellDef="let element"> {{element.cropYear}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="contractDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="accName"> Contract Description </th>
                <td mat-cell *matCellDef="let element"> {{element.contractDescription}} </td>
                <td mat-footer-cell *matFooterCellDef> Pending: {{getPendingCount()}} Active: {{getActiveCount()}} </td>
              </ng-container>
              <ng-container matColumnDef="supplier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="Supplier text-center"> Supplier </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.supplier}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="contractType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="type text-center"> Type </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="element.productSegment==='02'"> CPP </span>
                  <span *ngIf="element.productSegment==='04'"> SEED </span>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="requestedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center"> Request Date </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.requestedDate| date:'MM/dd/yyyy'}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center"> Status </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <button class="roundedBtn" *ngIf="element.status === 'P'">PENDING</button>
                  <button class="roundedBtn" *ngIf="element.status === 'A'">ACTIVE</button>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="amountRequested">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="amountReq text-center"> Amount Requested </th>
                <td mat-cell *matCellDef="let element" class="text-center"> <span>${{element.amountRequested| number : '1.2-2'}} </span></td>
                <td mat-footer-cell *matFooterCellDef class="text-center"> <span>${{getTotalAmountRequested()| number : '1.2-2'}}</span>  </td>
              </ng-container>
              <ng-container matColumnDef="currentBalance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="currentBal text-center"> Current Balance </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>${{element.currentBalance| number : '1.2-2'}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef class="text-center"> <span>${{getTotalCurrentBalance()| number : '1.2-2'}}</span> </td>
              </ng-container>
              <ng-container matColumnDef="contextMenu">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="actionBtn">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div>
                    <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                      <button mat-menu-item *ngIf="element.status === 'P'" (click)="navigateToContractInfo(element)">Edit Request</button>
                      <button mat-menu-item *ngIf="element.status === 'P'" (click)="cancelContractrequest(element)">Cancel Request</button>
                      <button mat-menu-item *ngIf="element.status === 'A'" (click)="navigateToContractInfo(element)">View Transactions</button>
                      <button mat-menu-item (click)="generatePdf(element)" *ngIf="element.status === 'A'">Download Statement Pdf</button>
                      <button mat-menu-item (click)="exportResult(element)" name="Excel" *ngIf="element.status === 'A'">Download Statement Excel</button>
                    </mat-menu>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="contractsColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: contractsColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="activePendingFooterContractsColumns; sticky: true"></tr>
            </table>
            <div *ngIf="activePendingContractsList == undefined || activePendingContractsList.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <i class="icon-ico-dealer_icon" aria-hidden="true"></i>
            <div class="tab-head">
              <h4>
                Closed Contracts
              </h4>
            </div>
          </ng-template>
          <div class="fulfill-top-sec">
            <div class="row listing-action-items">
              <div class="col-sm-4">
              </div>
              <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                <div class="display-ib wAuto">
                  <mat-paginator #closedContractsPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
                </div>
              </div>
            </div>
          </div>
          <div class="tableContainer dealertableContainer">
            <table mat-table #closedContractsTable [dataSource]="closedContractsDataSource" matSort #closedContractsSort matSortDirection="desc" class="matTables">

              <ng-container matColumnDef="contractNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="prepayAcc"> Prepay Contract </th>
                <td mat-cell *matCellDef="let element" class="unitsText">
                  <div (click)="navigateToContractInfo(element)">
                    <a>{{element.contractNumber}}</a>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef class=""> Prepay Contracts: {{getClosedContracts()}} </td>
              </ng-container>
              <ng-container matColumnDef="cropYear">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="cropYear"> Crop Year </th>
                <td mat-cell *matCellDef="let element"> {{element.cropYear}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="contractDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="accName"> Contract Description </th>
                <td mat-cell *matCellDef="let element"> {{element.contractDescription}} </td>
                <td mat-footer-cell *matFooterCellDef> Closed: {{getClosedContracts()}} </td>
              </ng-container>
              <ng-container matColumnDef="supplier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="Supplier text-center"> Supplier </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.supplier}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="contractType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="type text-center"> Type </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="element.productSegment==='02'"> CPP </span>
                  <span *ngIf="element.productSegment==='04'"> SEED </span>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="requestedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="requestDate text-center"> Request Date </th>
                <td mat-cell *matCellDef="let element" class="text-center"> {{element.requestedDate| date:'MM/dd/yyyy'}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="status text-center"> Status </th>
                <td mat-cell *matCellDef="let element" class="text-center">  <button class="roundedBtn">CLOSED </button></td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>
              <ng-container matColumnDef="amountRequested">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="amountReq text-center"> Amount Requested </th>
                <td mat-cell *matCellDef="let element" class="text-center"> <span>${{element.amountRequested| number : '1.2-2'}}</span> </td>
                <td mat-footer-cell *matFooterCellDef class="text-center"> <span>${{getTotalClosedContractAmountRequested()| number : '1.2-2'}}</span> </td>
              </ng-container>
              <ng-container matColumnDef="currentBalance">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="currentBal text-center"> Current Balance </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>${{element.currentBalance| number : '1.2-2'}}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef class="text-center"> <span>${{getTotalClosedCurrentBalance()| number : '1.2-2'}}</span> </td>
              </ng-container>
              <ng-container matColumnDef="contextMenu">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="actionBtn">&nbsp;</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <div>
                    <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
                      <button mat-menu-item (click)="navigateToContractInfo(element)">View Transactions</button>
                      <button mat-menu-item (click)="generatePdf(element)">Download Statement Pdf</button>
                      <button mat-menu-item (click)="exportResult(element)">Download Statement Excel</button>
                    </mat-menu>
                  </div>
                </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="contractsColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: contractsColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="closedFooterContractsColumns; sticky: true"></tr>
            </table>
            <div *ngIf="closedContractsList == undefined || closedContractsList.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
